import React, { useState } from 'react';
import api from './api';
import { couleurs, espace, rayon, texte, champ as champStyle, bouton } from './theme';
import logoJums from './logo-jums.png';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [loading, setLoading] = useState(false);

  const connexion = async () => {
    if (!email || !motDePasse) {
      setErreur('Email et mot de passe obligatoires');
      return;
    }
    setLoading(true);
    setErreur('');
    try {
      const res = await api.post(
        '/auth/login',
        new URLSearchParams({ username: email, password: motDePasse }),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
      localStorage.setItem('token', res.data.access_token);
      localStorage.setItem('role', res.data.role);
      if (res.data.borne_id) localStorage.setItem('borne_id', res.data.borne_id);
      if (res.data.festival_id) localStorage.setItem('festival_id', res.data.festival_id);
      onLogin(res.data);
    } catch (e) {
      setErreur('Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="jums-page" style={styles.container}>
      <div style={styles.card}>
        <img src={logoJums} alt="JUMS" style={styles.marque} />
        <h1 style={styles.titre}>Gestion des gobelets consignés</h1>
        <p style={styles.sousTitre}>Identifiez-vous pour accéder à la console.</p>

        <div style={styles.champ}>
          <label style={styles.label} htmlFor="login-email">Email</label>
          {/* Remplissage automatique désactivé le 2026-08-27.

              Ce n'est pas un caprice d'ergonomie : la console tourne sur
              un PC posé sur place, en régie, que n'importe qui peut
              ouvrir. Avec l'identifiant et le mot de passe pré-remplis,
              quiconque soulève l'écran est à un clic de l'administration
              complète — création de comptes, suppression de festival,
              remboursements.

              Attention : ceci empêche le navigateur de REMPLIR le champ,
              pas de RETENIR le mot de passe. S'il est déjà enregistré
              dans le navigateur, il faut l'y supprimer à la main. */}
          <input
            id="login-email"
            style={styles.input}
            type="email"
            autoComplete="off"
            placeholder="admin@festival.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && connexion()}
          />
        </div>

        <div style={styles.champ}>
          <label style={styles.label} htmlFor="login-mdp">Mot de passe</label>
          <input
            id="login-mdp"
            style={styles.input}
            type="password"
            autoComplete="new-password"
            data-lpignore="true"
            data-1p-ignore="true"
            placeholder="••••••••"
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && connexion()}
          />
        </div>

        {/* `role="alert"` : l'échec de connexion est annoncé aux
            lecteurs d'écran, il n'apparaît pas qu'en rouge. */}
        {erreur && <p style={styles.erreur} role="alert">{erreur}</p>}

        <button
          style={{ ...styles.bouton, opacity: loading ? 0.6 : 1,
                   cursor: loading ? 'progress' : 'pointer' }}
          onClick={connexion}
          disabled={loading}
        >
          {loading ? 'Connexion…' : 'Se connecter'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  // Fond uni clair, carte centrée sans ombre : l'écran de connexion
  // annonce le registre du reste de l'outil dès la première seconde.
  container: {
    minHeight: '100vh', background: couleurs.fond,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: espace.xl,
  },
  card: {
    background: couleurs.surface,
    border: `1px solid ${couleurs.bord}`,
    borderRadius: rayon.xl,
    padding: 36, width: 380, maxWidth: '100%',
  },
  // Le logo remplace le mot ecrit en petites capitales (01/09/2026).
  marque: { height: 22, width: 'auto', display: 'block', marginBottom: espace.lg },
  titre: { ...texte.titre, marginBottom: espace.xs },
  sousTitre: { ...texte.aide, margin: `0 0 ${espace.xl}px` },
  champ: { display: 'flex', flexDirection: 'column', gap: 5, marginBottom: espace.lg },
  label: { fontSize: 12.5, color: couleurs.encreDouce, fontWeight: 500 },
  input: { ...champStyle, padding: '10px 12px', fontSize: 14 },
  bouton: { ...bouton('primaire'), width: '100%', padding: 11, marginTop: espace.sm },
  erreur: {
    color: couleurs.danger, background: couleurs.dangerDoux,
    border: `1px solid ${couleurs.dangerDoux}`, borderLeft: `2px solid ${couleurs.danger}`,
    borderRadius: `0 ${rayon.md}px ${rayon.md}px 0`,
    fontSize: 12.5, padding: '8px 11px', margin: `0 0 ${espace.md}px`,
  },
};
